import {
  clearDurableStateValue,
  MAPPING_WORKSPACE_ONBOARDING_STORAGE_KEY,
  setDurableStateValue,
} from '../../../shared/lib/durableState/durableState';

const MAPPING_WORKSPACE_ONBOARDING_KEY = MAPPING_WORKSPACE_ONBOARDING_STORAGE_KEY;

// Reads hit localStorage (restored from the plugin-mirrored durable store at
// bootstrap); writes go through the durable mirror so the "I've already seen
// the mapping workspace onboarding" flag survives browser restart / tab close
// and WebView2 cache purges — session-scoped or local-only storage re-pops the
// onboarding every fresh session.
const mappingWorkspaceStorage = (): Storage | null => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export const hasSeenMappingWorkspaceOnboarding = (): boolean =>
  mappingWorkspaceStorage()?.getItem(MAPPING_WORKSPACE_ONBOARDING_KEY) === '1';

export const markMappingWorkspaceOnboardingSeen = (): void => {
  try {
    setDurableStateValue(MAPPING_WORKSPACE_ONBOARDING_KEY, '1');
  } catch {
    // Ignore storage failures; onboarding can reopen next visit.
  }
};

/**
 * Wipes the "have I seen the mapping workspace onboarding" flag so the next
 * mount auto-opens the summary again. Useful for a future "Reset tour state"
 * menu action and for tests; not invoked automatically.
 */
export const resetMappingWorkspaceOnboardingState = (): void => {
  try {
    clearDurableStateValue(MAPPING_WORKSPACE_ONBOARDING_KEY);
  } catch {
    // Ignore storage failures.
  }
};
